import { useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import {
  DeleteOutlined,
  UploadOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import { Flex, Modal, Typography, Upload } from 'antd'

import { Uploading } from '../../../components/importers/helperComponents'

import { deleteRequest, postRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'
import Button from '../../../antd/common/Button'
import EllipsisTooltip from '../../../antd/common/EllipsisTooltip'

const UploadSvgImage = ({
  id,
  className,
  svgImageFilename,
  svgDisplayName,
  getPowerDistributions,
}) => {
  const intl = useIntl()
  const { vehicle } = useParams()

  const [value, dispatch] = useContext(NavContext)

  const [uploadingState, setUploadingState] = useState(false)
  const [modal, contextHolder] = Modal.useModal()

  const deleteSVG = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'powerDistributions.deletingSvg' }),
        showLoader: true,
      },
      notification: {},
    })
    let res = await deleteRequest(
      `/api/power_distributions/delete_svg/${vehicle}/${id}/`
    )

    getPowerDistributions()

    setTimeout(() => {
      dispatch({
        type: 'notification',
        data: {
          notification_type: res.status ? 'success' : 'error',
          msg: intl.formatMessage({
            id: res.status
              ? 'powerDistributions.svgDeleteSuccess'
              : 'powerDistributions.svgDeleteFailed',
          }),
        },
      })
    }, 1000)
  }

  const confirmDeleteSvg = () => {
    const title = intl.formatMessage({ id: 'powerDistributions.deleteSvgTitle' })
    const content = intl.formatMessage({ id: 'powerDistributions.deleteSvgConfirm' })

    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk: () => {
        deleteSVG()
      },
      centered: true,
      maskClosable: true,
    })
  }

  const uploadFile = async ({ file }) => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'powerDistributions.uploadingSvg' }),
        showLoader: true,
      },
    })

    const formData = new FormData()
    formData.append('svg', file)

    setUploadingState(true)
    const res = await postRequest(
      `/api/power_distributions/upload_svg/${vehicle}/${id}/`,
      formData
    )
    setUploadingState(false)

    dispatch({
      type: 'notification',
      data: {
        notification_type: res.status ? 'success' : 'error',
        msg: intl.formatMessage({
          id: res.status
            ? 'powerDistributions.svgUploadSuccess'
            : 'powerDistributions.svgUploadFailed',
        }),
      },
    })

    setTimeout(() => {
      getPowerDistributions()
    }, 5000)

    return false // prevent Upload from auto-uploading
  }

  return (
    <>
      {contextHolder}

      <Flex vertical gap={8} className={className}>
        {uploadingState && <Uploading />}

        {svgImageFilename ? (
          <Flex align="center" gap={0}>
            <EllipsisTooltip className="ellipsis">
              {svgDisplayName}
            </EllipsisTooltip>

            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={confirmDeleteSvg}
            />
          </Flex>
        ) : (
          <Upload
            accept=".svg"
            showUploadList={false}
            beforeUpload={(file) => {
              uploadFile({ file })
              return false
            }}
          >
            <Button
              type="link"
              className="link-button"
              icon={<UploadOutlined />}
              loading={uploadingState}
            >
              {intl.formatMessage({ id: 'powerDistributions.uploadSvgImage' })}
            </Button>
          </Upload>
        )}
      </Flex>
    </>
  )
}

export default UploadSvgImage
